import { ReactNode } from 'react';
import { Card, CardContent } from '@/components/ui/card';

interface AuthLayoutProps {
    children: ReactNode;
    imageSrc?: string;
    imageAlt?: string;
    logoPosition?: 'center' | 'none';
}

export default function AuthLayout({
    children,
    imageSrc = "/forgot.jpg",
    imageAlt = "Authentication",
    logoPosition = 'center'
}: AuthLayoutProps) {
    return (
        <div className="min-h-screen bg-gradient-to-br from-muted to-muted flex items-center justify-center p-4">
            <div className="w-full max-w-md">
                <Card className="border-0  rounded-3xl overflow-hidden backdrop-blur-sm bg-card/95">
                    <CardContent className="p-0">
                        {/* Background Image Section */}
                        <div className="relative h-48 bg-gradient-to-br from-foreground-soft to-foreground overflow-hidden">
                            <img
                                src={imageSrc}
                                alt={imageAlt}
                                className="w-full h-full object-cover opacity-60"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-foreground/40 to-transparent" />

                            {/* Logo overlay - positioned in center of image */}
                            {logoPosition === 'center' && (
                                <div className="absolute inset-0 flex items-center justify-center">
                                    <img
                                        src="/LogoWhite.png"
                                        alt="LarkPM Logo"
                                        className="h-16 w-auto object-contain drop-"
                                    />
                                </div>
                            )}
                        </div>

                        {/* Content Section */}
                        <div className="px-8 py-10 bg-card">
                            {children}
                        </div>
                    </CardContent>
                </Card>

                {/* Legal links — public pages required by OAuth provider verification */}
                <p className="mt-4 text-center text-xs text-muted-foreground">
                    <a href="/privacy" className="hover:text-foreground underline-offset-2 hover:underline">Privacy Policy</a>
                    <span className="mx-2">·</span>
                    <a href="/terms" className="hover:text-foreground underline-offset-2 hover:underline">Terms of Service</a>
                </p>
            </div>
        </div>
    );
}
